// Benepack OMS · P2-5 · 共享 LinkCell (UI-1/UI-2 · 旧 X12 键盘可达性)
//
// 替代列表/详情里的 <a onClick={() => nav(...)}> 反模式:
//   - 无 href 的 <a> 不可 Tab 聚焦 · 不可回车触发 · 不能中键/⌘+click 新标签打开 · 无右键「复制链接」。
//   - React Router <Link> 渲染真 <a href> (SPA 拦截左键 · 修饰键/中键走浏览器原生) ·
//     AntD 全局 a 样式原样生效 → 外观与旧 <a> 一致。
// 用法: <LinkCell to={`/trade/sales-orders/${r.ID}`}>{r.SoNo}</LinkCell>
// 非导航动作 (如清空选择) 不要用本组件 · 用 Button type="link"。
import { Link } from 'react-router-dom';

export interface LinkCellProps {
  /** 站内路由路径 (react-router to)。 */
  to: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  /** 额外点击副作用 (如关闭弹层) · 不阻断导航。 */
  onClick?: React.ComponentProps<'a'>['onClick'];
}

export function LinkCell({ to, children, className, style, onClick }: LinkCellProps) {
  return (
    <Link to={to} className={className} style={style} onClick={onClick}>
      {children}
    </Link>
  );
}

export default LinkCell;
